import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;
`;

export const containerPhoto = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1rem;

	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
	}
`;

export const containerBtns = styled.div`
	margin-top: 1rem;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	> button {
		cursor: pointer;
		border: none;
		border-radius: 5px;
		width: 100%;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		transition: all ease 0.2s;

		:hover {
			opacity: 0.8;
		}
	}
`;

export const save = styled.button`
	background-color: ${color.system.success};
`;

export const cancel = styled.button`
	background-color: ${color.system.error};
`;

export const noticePassword = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	p {
		color: ${color.system.warning};
	}
`;
